export default "__VITE_ASSET__JQ1I3A8M__"